var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"element",staticClass:"hoverable-image-wrapper"},_vm._l((_vm.sources),function(src){return _c('img',{attrs:{"src":src},on:{"click":_vm.handleHoverMobile}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }